"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGlobalLogger = exports.getGlobalObject = void 0;
var GLOBAL_KEY = 'logger';
/**
 * Get the global object.
 *
 * Could perhaps be replaced with globalThis in future.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
 */

var getGlobalObject = function getGlobalObject() {
  var globalThis = typeof window === 'undefined' ? global : window;
  globalThis.IM = globalThis.IM || {};
  return globalThis.IM;
};
/**
 * Assign the global logger to the global object.
 */


exports.getGlobalObject = getGlobalObject;

var assignGlobalLogger = function assignGlobalLogger(newInstance) {
  var globalObj = getGlobalObject();

  if (!globalObj[GLOBAL_KEY]) {
    globalObj[GLOBAL_KEY] = newInstance;
    return newInstance;
  }

  var oldInstance = Object.create(globalObj[GLOBAL_KEY]);
  Object.keys(globalObj[GLOBAL_KEY]).forEach(function (prop) {
    oldInstance[prop] = globalObj[GLOBAL_KEY][prop];
    delete globalObj[GLOBAL_KEY][prop];
  });
  Object.getOwnPropertySymbols(globalObj[GLOBAL_KEY]).forEach(function (prop) {
    oldInstance[prop] = globalObj[GLOBAL_KEY][prop];
    delete globalObj[GLOBAL_KEY][prop];
  });
  Object.keys(newInstance).forEach(function (prop) {
    globalObj[GLOBAL_KEY][prop] = newInstance[prop];
  });
  Object.getOwnPropertySymbols(newInstance).forEach(function (prop) {
    globalObj[GLOBAL_KEY][prop] = newInstance[prop];
  });
  return oldInstance;
};
/**
 * Set the global logger.
 */


var setGlobalLogger = function setGlobalLogger(newLogger) {
  var types = Object.keys(newLogger._types);
  var globalObj = getGlobalObject();
  var currentLogger = globalObj[GLOBAL_KEY] || {};
  var currentLoggerKeys = Object.keys(currentLogger);
  var _currentLogger$queue = currentLogger.queue,
      queue = _currentLogger$queue === void 0 ? [] : _currentLogger$queue;
  var hasAllLogTypes = !types.find(function (type) {
    return !currentLoggerKeys.includes(type);
  }); // Only set the global logger once

  if (hasAllLogTypes) {
    return;
  }

  assignGlobalLogger(newLogger); // Unset the global consola instance, which gets set on import

  if (global.consola) {
    delete global.consola;
  } // Catch anything still logged directly to `console`


  types.forEach(function (type) {
    // Backup original value
    if (!console["__".concat(type)]) {
      console["__".concat(type)] = console[type];
    } // Overide original value


    console[type] = function () {
      var _globalObj$GLOBAL_KEY;

      (_globalObj$GLOBAL_KEY = globalObj[GLOBAL_KEY])[type].apply(_globalObj$GLOBAL_KEY, arguments);
    };
  }); // Run any functions that were queued up before the logger was created

  queue.forEach(function (func) {
    return func();
  }); // And run any functions queued after

  globalObj[GLOBAL_KEY].queue = {
    push: function push(func) {
      return func();
    }
  };
};

exports.setGlobalLogger = setGlobalLogger;